import * as React
    from 'react';
import MuiTextField
    from '@mui/material/TextField';

const TextField = ({
                       className,
                       readOnly = false,// This prop seems to be left out of MUI for some reason, so we're adding it here.
                       inputProps = {},
                       ...rest
                   }) => {
    let classNames = ['bg-white', className].filter(Boolean).join(" ").trim();

    return (
        <MuiTextField
            className={classNames}
            inputProps={{readOnly, ...inputProps}}
            {...rest}
        />
    );
};

export default TextField;